const component = require('../component/component');

const input = Object.assign({}, component, {
    subelements: {
        copyToClipboard: null,
        confirmEdit: null,
        validationMessage: null
    },
    validationTriggeringEvents: ['keyup'],

    init: function () {
        component.init.call(this);

        if (this.hasSubelement('copyToClipboard')) {
            this.subelements.copyToClipboard.onclick = () => { this.doCopyToClipboard(); };
        }

        if (this.hasSubelement('confirmEdit')) {
            this.subelements.confirmEdit.onclick = () => { this.doToggleEdit(); };
        }
    },

    doCopyToClipboard: function () {
        this.element.select();
        this.element.setSelectionRange(0, 99999);

        navigator.clipboard.writeText(this.getValue());

        confirmMessage = {
            type: 'info',
            text: 'textCopiedToClipboard'
        };

        this.hm.msgs.show(confirmMessage);
    },

    doToggleEdit: function () {
        // The icon swaps between the "edit" and "cancel" semantic icons from
        // the theme's icon map (see scripts/icons.contract.md). The template
        // renders this <i> with `{$_themeIcons.edit} {$_cssClasses.iconSizeRegular}`; we replace the
        // whole className so multi-word icon class strings (e.g.
        // `ki-outline ki-message-edit`) toggle cleanly.
        let iconElement = this.subelements.confirmEdit.querySelector('i');
        if (this.element.readOnly) {
            //make editable
            this.element.readOnly = false;
            iconElement.className = (this.hm.app.icons.cancel ?? '') + ' ' + this.hm.app.cssClass('iconSizeRegular');
            this.subelements.confirmEdit.attributes.title.value = this.hm.app.utext('cancel');
        } else {
            //cancel & make read only again
            this.element.readOnly = true;
            this.setValue(this.initialValue);
            iconElement.className = (this.hm.app.icons.edit ?? '') + ' ' + this.hm.app.cssClass('iconSizeRegular');
            this.subelements.confirmEdit.attributes.title.value = this.hm.app.utext('edit');
        }
        this.hm.validator.resetValidation(this);
    }
});

module.exports = input;